import { Component, OnInit, ViewChild } from '@angular/core';
import { InternalHomeService } from '../../internal-home.service';
import { Fieldlinks } from '../../../../../core/entities/fieldlinks.model';
import { MatDialog } from '@angular/material/dialog';
import { EditDialogsFieldlinksComponent } from './dialogs-fieldlinks/edit-dialogs-fieldlinks/edit-dialogs-fieldlinks.component';
import { DialogsConfirmComponent } from '../../../../../shared/components/dialogs/dialogs-confirm/dialogs-confirm.component';
import { DialogsPermissionsComponent } from '../../../../../shared/components/dialogs/dialogs-permissions/dialogs-permissions.component';
import { TranslateService } from '@ngx-translate/core';
import { FormCanDeactivate } from '../../../../../core/guards/deactivate/form-can-deactivate';
import { NgForm } from '@angular/forms';
import { Utils } from 'src/app/core/utils/utils';
import { DialogsAlertComponent } from 'src/app/shared/components/dialogs/dialogs-alert/dialogs-alert.component';
import { UNAUTHORIZED, FORBIDDEN } from '../../../../../core/utils/constants';

@Component({
  selector: 'app-fieldlinks',
  templateUrl: './fieldlinks.component.html',
  styleUrls: ['./fieldlinks.component.scss']
})
export class FieldlinksComponent extends FormCanDeactivate implements OnInit {

  @ViewChild('f', {static: true})
  form!: NgForm;
  loading: boolean = true;
  fieldlink: Fieldlinks = new Fieldlinks();

  mensajeError: boolean = false;

  constructor(public internalHomeService: InternalHomeService,
    private dialog: MatDialog,
    private translateService: TranslateService) {
    super();
  }

  ngOnInit() {
    this.mensajeError = false;
    this.getAllFieldlinks();
    this.internalHomeService.mostrarMenu();
  }

  /**
  * @description
  * Se llama al servicio para traernos todos los datos de la tabla fieldlinks
  */
  private getAllFieldlinks(): void {
    this.loading = true;
    this.internalHomeService.allFieldlinks().subscribe(res => {
        console.log(res);
        this.loading = false;
    }, error => {
        this.mensajeError = true;
        this.loading = false;
        this.showMsg(error);
        console.log("Error: " + error);
    });
  }

  /**
  * @description
  * Abre el dialog para crear un fieldlink
  * @param fieldlink Opcional. Fieldlink vacio.
  */
  public createFieldlink(fieldlink?: Fieldlinks) {
    Utils.toggleAllButtonsAndHref(true);
    let titulochange = false;
    fieldlink = this.fieldlink;
    fieldlink.icon = "";
    let anchodisp: string = "";
    window.screen.width < 500 ? anchodisp = '85%' : anchodisp = "50%";
    const dialogRef = this.dialog.open(EditDialogsFieldlinksComponent, {
      width: anchodisp,
      disableClose: true,
      hasBackdrop: true,
      data: { fieldlink, titulochange }
    });
    Utils.accessibilityDialogCdk();
    dialogRef.afterClosed().subscribe((result: boolean) => {
      Utils.toggleAllButtonsAndHref(false);
      if(result)
      setTimeout(() => {
        this.getAllFieldlinks();
      }, 1000);
    });
  }

  /**
  * @description
  * Abre el dialog para modificar un fieldlink
  * @param fieldlink Opcional. Fieldlink a editar.
  */
  public editFieldlink(fieldlink?: Fieldlinks) {
    Utils.toggleAllButtonsAndHref(true);
    let titulochange = true;
    let anchodisp: string = "";
    window.screen.width < 500 ? anchodisp = '85%' : anchodisp = "50%";
    const dialogRef = this.dialog.open(EditDialogsFieldlinksComponent, {
      width: anchodisp,
      disableClose: true,
      hasBackdrop: true,
      data: { fieldlink, titulochange}
    });
    Utils.accessibilityDialogCdk();
    dialogRef.afterClosed().subscribe((result: boolean) => {
      Utils.toggleAllButtonsAndHref(false);
      if(result)
      setTimeout(() => {
        this.getAllFieldlinks();
      }, 1000);
    });
  }

  /**
  * @description
  * Elimina un fieldlink
  * @param fieldlink Fieldlink a eliminar
  */
  public removeFieldlink(fieldlink?: Fieldlinks) {
    Utils.toggleAllButtonsAndHref(true);
    const dialogRef = this.dialog.open(DialogsConfirmComponent, {
      disableClose: true,
      hasBackdrop: true,
      data: { texto: this.translateService.instant('WARNINGS.dato_fieldlinks') }
    });
    Utils.accessibilityDialogCdk();
    dialogRef.afterClosed().subscribe(result => {
      Utils.toggleAllButtonsAndHref(false);
      if (result) {
        this.loading = true;
        this.internalHomeService.removeFieldlinks(fieldlink).subscribe(res => {
          console.log(res);
          this.getAllFieldlinks();
          this.loading = false;
        }, error => {
          this.loading = false;
          console.log("Error: " + error);
        });
      }
    });
  }

  /**
  * @description
  * Abre el dialog para modificar lois permisos de un fieldlink
  * @param fieldlink Fieldlink a cambiar los permisos.
  */
  public permissionFieldlink(fieldlink?: Fieldlinks){
    Utils.toggleAllButtonsAndHref(true);
    let titulochange = true;
    let clasepermisos = this.translateService.instant('TABLAS.fieldlink');
    let objectpermisos;
    let idpermisos;
    if(fieldlink){
      objectpermisos = fieldlink.code;
      idpermisos = fieldlink.id;
    }
    console.log(fieldlink);
    const dialogRef = this.dialog.open(DialogsPermissionsComponent, {
      width: '85%',
      disableClose: true,
      hasBackdrop: true,
      data: { fieldlink, titulochange, clasepermisos, objectpermisos, idpermisos }
    });
    Utils.accessibilityDialogCdk();
    dialogRef.afterClosed().subscribe((result: Fieldlinks) => {
      Utils.toggleAllButtonsAndHref(false);
      console.log(result);
    });
  }

  /**
  * Muestra el mensaje de error correspondiente en caso de error
  * @param error Objeto de error.
  */
  private showMsg(error: any) {
    const msg: string = error == null || (error != null && (error.status !== UNAUTHORIZED && error.status !== FORBIDDEN)) ? this.translateService.instant('ACCESO.loginError') : this.translateService.instant('ACCESO.loginError' + error.status);
    this.dialog.open(DialogsAlertComponent, {
      data: { texto: msg }
    });
  }

}
